<template>
    <administrative>

        <card-header :title="'Branch: '+branch.title+' - '+branch.code"/>
        <div class="grid  gap-4">
            <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
                <loading :showLoading="selectform.processing"/>

                <div :class="{'opacity-50':selectform.processing,'opacity-100':!selectform.processing}">
                    <p class="text-lg font-medium mb-4">Branch Staff</p>
                    <form @submit.prevent="assignStaff">
                        <div>
                            <div class="divide-y">
                                <div
                                    class="flex flex-wrap gap-4 mb-6 pt-6"
                                    v-for="(staff,index) in selectform.staffs"
                                    :key="index"
                                >
                                    <div class="">

                                        <FormMultiselect
                                            class="w-96"
                                            :required="true"
                                            returnValue="id"
                                            :disabled="staff?.old_id"
                                            :options="staffsOptions"
                                            track-key="id"
                                            label-key="title"
                                            v-model="selectform.staffs[index].staff"
                                            :placeholder="'Select Staff'"
                                            :error="selectform.errors?.staffs ? selectform.errors?.staffs[`staffs.${index}.staff`]:''"
                                        />
                                    </div>

                                    <div class="">
                                        <!-- <select-list
                                            required
                                            :returnId="true"
                                            :disabled="staff?.old_id&&!staff.department.id==''"
                                            v-model="staff.department"
                                            :options="departmentsOptions"
                                            :placeholder="'Select Department'"
                                            class="w-full"
                                        /> -->
                                        <FormMultiselect
                                            class="w-56"
                                            :required="true"
                                            :disabled="staff?.old_id&&!staff.department==''"
                                            :options="departments"
                                            track-key="id"
                                            label-key="name"
                                            returnValue="id"
                                            v-model="selectform.staffs[index].department"
                                            :placeholder="'Select Department'"
                                            :error="selectform.errors?.staffs ? selectform.errors?.staffs[`staffs.${index}.department`]:''"
                                        />
                                    </div>
                                    <div class="">
                                        <!-- <select-list
                                            required
                                            :returnId="true"
                                            :disabled="staff?.old_id&& !staff.designation.id==''"
                                            v-model="staff.designation"
                                            :options="designationsOptions"
                                            :placeholder="'Select Designation'"
                                            class="w-full"
                                        /> -->

                                        <FormMultiselect
                                            class="w-56"
                                            :required="true"
                                            :disabled="staff?.old_id&& !staff.designation==''"
                                            :options="designations"
                                            track-key="id"
                                            label-key="name"
                                            returnValue="id"
                                            v-model="selectform.staffs[index].designation"
                                            :placeholder="'Select Designations'"
                                            :error="selectform.errors?.staffs ? selectform.errors?.staffs[`staffs.${index}.designation`]:''"
                                        />
                                    </div>
                                    <div class="">
                                        <!-- <select-list
                                            required
                                            :returnId="true"
                                            v-model="staff.duration"
                                            :disabled="staff?.old_id&& !staff.duration.id==''"
                                            :options="durationOptions"
                                            :placeholder="'Duration'"
                                            class="w-full"
                                        /> -->
                                        <FormMultiselect
                                            class="w-56"
                                            :options="durationOptions"
                                            :disabled="staff?.old_id&& !staff.duration==''"
                                            track-key="id"
                                            label-key="title"
                                            returnValue="id"
                                            v-model="selectform.staffs[index].duration"
                                            :placeholder="'Select Duration'"
                                            :error="selectform.errors?.staffs ? selectform.errors?.staffs[`staffs.${index}.duration`]:''"
                                        />
                                    </div>
                                    <div class="">
                                        <!-- <select-list
                                            required
                                            :returnId="true"
                                            :disabled="staff?.old_id && !staff.year.id==''"
                                            v-model="staff.year"
                                            :options="datesOptions"
                                            :placeholder="'Joining Year'"
                                            class="w-full"
                                        /> -->

                                        <FormMultiselect
                                            class="w-56"
                                            :options="datesOptions"
                                            :disabled="staff?.old_id && !staff.year==''"
                                            track-key="id"
                                            label-key="title"
                                            returnValue="id"
                                            v-model="selectform.staffs[index].year"
                                            :placeholder="'Joining Year'"
                                            :error="selectform.errors?.staffs ? selectform.errors?.staffs[`staffs.${index}.year`]:''"
                                        />
                                    </div>
                                    <svg

                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-6 w-6 text-red-500 justify-self-center cursor-pointer"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        @click="removeStaff(index,staff?.old_id)"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"
                                        />
                                    </svg>
                                    <hr class="col-span-8">
                                </div>
                            </div>
                            <div class="flex  space-x-2">
                                <breeze-button :type="'button'" class="" @click="addUser">Add</breeze-button>
                                <div>
                                    <button-link
                                        :href="route('administrative.branch.list')"
                                        class="bg-red-500 hover:bg-red-400"
                                    >Cancel
                                    </button-link>
                                </div>
                                <div>
                                    <breeze-button :disabled="form.processing">Next</breeze-button>
                                </div>
                                <exception/>
                            </div>
                        </div>


                    </form>
                </div>
            </div>

            <div v-if="hasRole('Create Staff')" class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
                <loading :showLoading="form.processing"/>
                <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                    <p class="text-lg font-medium mb-4">Add Staff</p>
                    <form @submit.prevent="submitForm">
                        <div class="grid grid-cols-8 gap-4 mb-4">
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'Name'"/>
                                <breeze-input required v-model="form.name" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.name:''"/>
                            </div>

                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'Mobile'"/>
                                <breeze-input required type="number" v-model="form.mobile" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.mobile:''"/>
                            </div>

                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Email'"/>
                                <breeze-input required v-model="form.email" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.email:''"/>
                            </div>

                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :value="'Date Of Birth'"/>
                                <breeze-input v-model="form.date_of_birth" type="date" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.date_of_birth:''"
                                />
                            </div>

                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :value="'Blood Group'"/>
                                <breeze-input v-model="form.blood_group" type="text" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.blood_group:''"
                                />
                            </div>

                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'Password'"/>
                                <breeze-input required v-model="form.password" class="w-full" type="password"/>
                                <breeze-input-error :message="form.errors?form.errors.password:''"/>
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <ProfileImageComponent
                                    required
                                    v-model="form.profile"
                                    :error-message="form.errors?.profile"/>
                            </div>


                        </div>
                        <button-link
                            :href="route('administrative.staff.list')"
                            class="bg-red-500 mr-4 hover:bg-red-400"
                        >Cancel
                        </button-link>
                        <breeze-button :disabled="form.processing">Save</breeze-button>
                        <exception/>
                    </form>
                </div>
            </div>
        </div>
    </administrative>
</template>

<script setup>
import Administrative from "@/Pages/Administrative/Administrative";
import BreezeInput from "@/Components/Input";
import BreezeLabel from "@/Components/Label";
import BreezeButton from "@/Components/Button";
import BreezeInputError from "@/Components/InputError";
import ButtonLink from "@/Components/ButtonLink";
import Exception from "@/Components/Exception";
import {useForm} from "@inertiajs/inertia-vue3";
import CardHeader from "@/Components/CardHeader";
import Loading from "@/Components/Loading";
import {computed, onMounted} from "vue";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import {hasRole} from "../../../../Utils/checkPermission";
import ProfileImageComponent from "@/Components/ProfileImageComponent.vue";


const props = defineProps({
    branch: Object,
    staffs: Object,
    departments: Object,
    designations: Object,
    duration: Object,
    dates: Object
});

const form = useForm({
    name: "",
    mobile: "",
    email: "",
    profile: "",
    password: "",
    blood_group: "",
    date_of_birth: "",
    branch_id: props.branch.id
});

const selectform = useForm({
    staffs: []
});

function assignStaff() {
    // selectform.staffs.map((item, i) => {
    //     item.department = item?.department?.id;
    //     item.designation = item?.designation?.id;
    //     item.staff = item?.staff?.id;
    //     item.year = item?.year?.id;
    //     item.duration = item?.duration?.id;
    // });
    selectform.post(
        route("administrative.staff.storeBranch", props.branch?.id),
        {
            preserveScroll: true,
            onSuccess: () => {
                location.reload();
                form.reset();
            }
        }
    );
}

function submitForm() {
    form.post(route("administrative.staff.store", props.branch?.id), {
        preserveScroll: true,
        onSuccess: () => {
            location.reload();
            form.reset();
        }
    });
}

function addUser() {
    selectform.staffs.push({});
}

function removeStaff(index, _id = 0) {
    selectform.staffs.splice(index, 1);
    if (_id) {
        axios.delete(route('administrative.staff.delete', [props.branch?.id, _id])).then((resp) => {
            console.log('done');
        })
    }
}

const staffsOptions = computed(() => {
    var data = [];
    props.staffs.forEach(item => {
        data.push({id: item.id, title: item.name});
    });
    return data;
});

const departmentsOptions = computed(() => {
    var data = [];
    props.departments.forEach(item => {
        data.push({id: item.id, title: item.name});
    });
    return data;
});

const designationsOptions = computed(() => {
    var data = [];
    props.designations.forEach(item => {
        data.push({id: item.id, title: item.name});
    });
    return data;
});

const durationOptions = computed(() => {
    var data = [];
    props.duration.forEach(item => {
        data.push({
            id: item.id,
            title: item.start_month + " - " + item.end_month
        });
    });
    return data;
});
const datesOptions = computed(() => {
    var data = [];
    props.dates.forEach(item => {
        data.push({id: item.toString(), title: item.toString()});
    });
    return data;
});

function showDefault() {
    props.branch.staff_branch.forEach(item => {
        selectform.staffs.push({
            department: item.department.id,
            designation: item.designation.id,
            staff: item.staff_id,
            year: item.year,
            duration: item.duration,
            old_id: item.id
        });
        //  data.push({id: item.id, title: item.name });
    });
}

onMounted(() => {
    showDefault();
});
</script>
